import React, { useEffect } from "react";
import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AccordionComponent, AccordionComponentProps } from "../components/AccordionComponent";
import { CustomerCaseDataRepresentationComponent, CustomerCaseDataRepresentationVariant } from "../components/datapresentation/CustomerCaseDataRepresentation";
import { ImageComponent } from "../components/ImageComponent";
import { getPath, Paths } from "../utils/paths";
import { DynamicContentComponent, DynamicContentItem } from "../components/DynamicContentComponent";
import { BreadcrumbComponent, BreadCrumProps } from "../components/BreadcrumComponent";
import { Link, useLocation, useSearchParams } from "react-router-dom";

type CustomerCaseProps = {
  title: String;
  problem: String;
  cause: String;
  solution: String;
  description: String;
  image?: String;
}

export const Customercases = () => {
  const { t, ready } = useTranslation("customercases");
  const [customerCases, setCustomerCases] = React.useState<CustomerCaseProps[]>([]);
  const [expanded, setExpanded] = React.useState<string | false>('accordion1');

  const [searchParams] = useSearchParams();

  if (!ready) return "loading translations...";

  const breadCrums = t("breadcrums", { returnObjects: true }) as BreadCrumProps[];
  
  const topDynamicContent = t("topContent", { returnObjects: true }) as DynamicContentItem[];

  const accordionTransformationContent = t("caseTransformation", { returnObjects: true }) as DynamicContentItem[];  
  const accordionJoinExistingTeamContent = t("caseJoinExistingTeam", { returnObjects: true }) as DynamicContentItem[];  
  

  const customerCaseAccordions = t("customercases:customercases", { returnObjects: true }) as CustomerCaseProps[];

  // Create and load list of customer cases on mount features on mount
  React.useEffect(() => {
    if (ready) {
      const customerCasesList = customerCaseAccordions.map((item) => ({
        title: item.title,
        problem: item.problem,
        cause: item.cause,
        solution: item.solution,
        description: item.description,
        image: item.image,
      }));
      setCustomerCases(customerCasesList);
    }
  }, [ready]);

  useEffect(() => {
    // check for open accordion param
    const queryParams = new URLSearchParams(searchParams);
    if (queryParams.get('openaccordion')) {
      if (queryParams.get('openaccordion') !== expanded) {
        setExpanded(queryParams.get('openaccordion') || '')
      }
    }
  }, [searchParams]);

  const handleChangeAccordion = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
     <>
      <ImageComponent
        imageSrc={`${getPath(Paths.IMAGES_MISC, false)}/happy-faces.jpg`}
        imageProps={{
          width: "100%",
          height: "auto"
        }}
      />
      <BreadcrumbComponent breadcrums={breadCrums} />
      <Box>
        <DynamicContentComponent
          items={topDynamicContent}
          key={"customer-cases-top-content"}
        />
      </Box>

      <AccordionComponent key={"case-transformation"} title={t("caseTransformationTitle")} headerImage={`${getPath(Paths.IMAGES_VENDORS, false)}/nuuday_small.png`} expanded={expanded == "accordion1"} onChange={handleChangeAccordion("accordion1")}>
        <DynamicContentComponent
          items={accordionTransformationContent}
          key={"case-transformation"}
          containerType="Box"
        />
      </AccordionComponent>

      <AccordionComponent key={"case-jointeam"} title={t("caseJoinExistingTeamTitle")} headerImage={`${getPath(Paths.IMAGES_VENDORS, false)}/nuuday_small.png`} expanded={expanded == "accordion2"} onChange={handleChangeAccordion("accordion2")}>
        <DynamicContentComponent
          items={accordionJoinExistingTeamContent}
          key={"case-jointeam"}
          containerType="Box"
        />
      </AccordionComponent>


{/*       <Box alignContent={"space-between"} alignItems={"center"} justifyContent={"normal"}>
      {customerCases.map((item, index) => {
        const accordionChangeName = `accordion${index}`
        return (
          <AccordionComponent key={`customer-case-${index}`} title={item.title} headerImage={item.image} expanded={expanded == accordionChangeName} onChange={handleChangeAccordion(accordionChangeName)}>
            <CustomerCaseDataRepresentationComponent
              title={item.title}
              problem={item.problem}
              cause={item.cause}
              solution={item.solution}
              description={item.description}
              variant={CustomerCaseDataRepresentationVariant.VARIANT1}
              image={item.image}
            />
          </AccordionComponent>
        )
      })}
      </Box>
 */}
     </>
  )
}

function useQuery() {
  throw new Error("Function not implemented.");
}
